import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';

function ClinicalStatusListTemplate({ clinicalStatusListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization
    } = clinicalStatusListViewStore;
    return (
        <ApplicationListLayout store={clinicalStatusListViewStore}>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} />
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='CLINICAL_STATUS.LIST.EMPTY_STATE.TITLE' description='CLINICAL_STATUS.LIST.EMPTY_STATE.DESCRIPTION' />
}

ClinicalStatusListTemplate.propTypes = {
    clinicalStatusListViewStore: PropTypes.object
};

export default defaultTemplate(ClinicalStatusListTemplate);
